import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";
import { getSettlementHeaderFields } from "../../helper/header";
import { useSettlementStore } from "../../store/settlementStore";
import { SETTLEMENT_STYLES } from "../../style/styles";

import HeaderActionButton from "./HeaderActionButton";

export default function SettlementHeader({
  onDownloadPdf,
  disableDownloadPdf = false,
}) {
  const caseDetail = useSettlementStore((state) => state.caseDetail);
  const headerFields = getSettlementHeaderFields(caseDetail);

  return (
    <div
      style={{
        background: `linear-gradient(
          91.64deg,
          ${HNSColors.primary[300]} -2.29%,
          ${HNSColors.primary[400]} 24.1%,
          ${HNSColors.primary[500]} 46.74%,
          ${HNSColors.tertiary[500]} 89.2%,
          ${HNSColors.tertiary[700]} 102.56%
        )`,
        boxShadow: `0px 3px 45px 0px ${HNSColors.tertiary[900]}`,
        color: HNSColors.neutrals[900],
      }}
      className="flex w-full flex-row gap-4 rounded-[12px] p-6"
    >
      <div className="flex items-start pt-1">
        <Svg
          name={SvgEnum.HisClipboardCheck}
          color={HNSColors.neutrals[900]}
          sx={SETTLEMENT_STYLES.sectionHeaderIcon}
        />
      </div>
      <div className="flex w-full flex-col gap-3">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <h2 className="text-2xl font-semibold leading-tight">Settlement Statement</h2>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex flex-1 flex-wrap items-center gap-3">
            {headerFields.map((field) => (
              <div
                key={field.label}
                style={{ backgroundColor: HNSColors.tertiary[900], color: HNSColors.primary[500] }}
                className="flex items-center gap-1 rounded-full px-4 py-2 text-sm font-medium"
              >
                <span className="font-semibold">{field.label}:</span>
                <span>{field.value}</span>
              </div>
            ))}
          </div>
          <div className="settlement-screen-only ml-auto">
            <HeaderActionButton
              icon={<FileDownloadOutlinedIcon />}
              onClick={onDownloadPdf}
              disabled={disableDownloadPdf}
            >
              Export Medical Summary
            </HeaderActionButton>
          </div>
        </div>
      </div>
    </div>
  );
}
